import { Box } from '#/components/Box/Box';
import { BodyMicro } from '#/components/Text/BodyMicro';
import { Underline } from '#/components/Text/Underline';
import { useI18n } from '#/i18n/hooks/useI18n';

import { CreditCardBrandImage } from './CreditCardBrandImage';

type Props = {
  brand: string | undefined;
};

export function CreditCardCvcTooltip({ brand }: Props) {
  const { i18n } = useI18n();

  if (!brand)
    return (
      <>
        <BodyMicro lineHeight={1.25} textAlign="left">
          {i18n(
            'For Visa, MasterCard and Discover, the {{b}}3 digits{{/b}} on the {{u}}back{{/u}} of your card (left).',
            { b: <strong />, u: <Underline /> },
          )}
        </BodyMicro>

        <BodyMicro lineHeight={1.25} textAlign="left" mt="8px">
          {i18n(
            'For American Express, the {{b}}4 digits{{/b}} on the {{u}}front{{/u}} of your card (right).',
            { b: <strong />, u: <Underline /> },
          )}
        </BodyMicro>

        <Box display="flex" mx="-4px" mt={18}>
          <Box width={1 / 2} px="4px">
            <CreditCardBrandImage />
          </Box>
          <Box width={1 / 2} px="4px">
            <CreditCardBrandImage isAmex />
          </Box>
        </Box>
      </>
    );

  if (brand === 'amex')
    return (
      <>
        <BodyMicro lineHeight={1.25} mb={12}>
          {i18n(
            'The {{b}}4 digits{{/b}} on the {{u}}front{{/u}} of your card',
            { b: <strong />, u: <Underline /> },
          )}
        </BodyMicro>
        <CreditCardBrandImage isAmex />
      </>
    );

  return (
    <>
      <BodyMicro lineHeight={1.25} mb={12}>
        {i18n('The {{b}}3 digits{{/b}} on the {{u}}back{{/u}} of your card', {
          b: <strong />,
          u: <Underline />,
        })}
      </BodyMicro>
      <CreditCardBrandImage />
    </>
  );
}
